<template>
  <WsMain>
    <WsCRUD
      ref="WsCRUD"
      :label="label"
      :fields="fields"
      :pageMode="true"
      :showExpand="false"
      :rowClickRead="true"
      :isCreatable="false"
      :modelName="modelName"
      :inRowBtnDelete="false"
      :inRowBtnUpdate="false"
      :showFields="showFields"
      :customUrlParams="customUrlParams"
      :wrapColumns="wrapColumns"
    />
  </WsMain>
</template>

<script>
import model from '@/models/act_idtf_overall_review';
import idtfModel from '@/models/act_idtf_assignment';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: idtfModel.fields,
      showFields: [
        'act_version',
        'idtf_reviewers',
        'overall_owners',
        'idtf_overall_reviewer',
        'idtf_overall_reviewed_at',
      ],
      customUrlParams: {
        status: '2',
        overall_review_status: '1',
      },
      wrapColumns: ['act_version'],
    };
  },
};
</script>